import React from 'react';

export function PasswordChecklist({ password }) {
  const rules = [
    { id:'len', pass: password.length >= 10, label: '≥ 10 caracteres' },
    { id:'upper', pass: /[A-Z]/.test(password), label: 'Una mayúscula' },
    { id:'lower', pass: /[a-z]/.test(password), label: 'Una minúscula' },
    { id:'num', pass: /\d/.test(password), label: 'Un número' },
    { id:'sym', pass: /[^A-Za-z0-9]/.test(password), label: 'Un símbolo' }
  ];
  return (
    <ul className="grid grid-cols-2 gap-x-4 gap-y-1 mt-3 text-[11px]">
      {rules.map(r => <li key={r.id} className={r.pass? 'text-success flex items-center gap-1':'text-gray-500 flex items-center gap-1'}>
        <span>{r.pass? '✔':'•'}</span><span>{r.label}</span>
      </li>)}
    </ul>
  );
}
